import commonStrings from '../../resources/commonStrings';

const tabDetails = {
  growthReports: {
    displayText: commonStrings.navigationTabTitle.growth,
    urlEndPoint: 'map',
  },
  operationalReports: {
    displayText: commonStrings.navigationTabTitle.operational,
    urlEndPoint: 'operational',
  },
  reportsQueue: {
    displayText: commonStrings.navigationTabTitle.reportsQueue,
    urlEndPoint: 'queue',
  },
};

export default tabDetails;
